import { defineMessages } from 'react-intl';

export default defineMessages({
  signServiceReportConfirmButton: {
    id: 'components.myaccount.claims.confirmation.signatureRequired.signServiceReportConfirmButton',
    defaultMessage: 'Sign',
  },
  signServiceReportError: {
    id: 'fieldService.interventions.signServiceReportError',
    defaultMessage: 'Failed to sign service report',
  },
  signServiceReportSuccess: {
    id: 'fieldService.interventions.signServiceReportSuccess',
    defaultMessage: 'Service report signed successfully',
  },
  signServiceReportTitle: {
    id: 'components.myaccount.claims.confirmation.signatureRequired.signServiceReportTitle',
    defaultMessage: 'Sign service report',
  },
});
